export const EMAIL_CHANGED = "EMAIL_CHANGED";
export const PASSWORD_CHANGED = "PASSWORD_CHANGED";
export const LOGOUT = "LOGOUT";
export const FAILED_LOGIN = "FAILED_LOGIN";
export const SUCCESS_LOGIN = "SUCCESS_LOGIN";
export const LNG_CHANGED = "LNG_CHANGED";
export const TAB_DASHBOARD_CHANGED = "TAB_DASHBOARD_CHANGED";

